import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import state from './state';

// modules
import filters from './modules/filters';
import forms from './modules/forms';
import tables from './modules/tables';
import tabs from './modules/tabs';
import users from './modules/users';
import version from './modules/version';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    tabs: state.tabs,
    tables: state.tables,
  }),
});

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    filters,
    tables,
    users,
    tabs,
    forms,
    version,
  },
  plugins: [vuexLocal.plugin],
});
